import { render, staticRenderFns } from "./FilePostIcon.vue?vue&type=template&id=5ca2a60e&"
import script from "./FilePostIcon.vue?vue&type=script&lang=js&"
export * from "./FilePostIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports